// Mock data for TribalRoot.AI clone

export const navigationItems = [
  { name: 'Ancestral Lineage', href: '/lineage' },
  { name: 'Tribal Vault', href: '/vault' },
  // { name: 'Tribal Feed', href: '/feed' }, // Temporarily removed
  { name: 'Crest Generator', href: '/crest' },
  { name: 'Healing Grounds', href: '/healing' },
  { name: 'Language Restoration', href: '/language' },
  { name: 'Tribal Table', href: '/table' },
  { name: 'Cosmic Codes', href: '/cosmic-codes' }
];

export const heroContent = {
  title: "The AI Portal to Ancestral Power",
  subtitle: "Reclaim your ancestral legacy, build lawful tribal infrastructure, and live in spiritual, physical, and legal sovereignty.",
  buttons: {
    primary: "Start Your Journey",
    secondary: ""
  }
};

export const tribalIdentityCard = {
  title: "Tribal Identity",
  subtitle: "Discover your true heritage",
  features: [
    "AI Genealogy Analysis",
    "Tribal Rights Education", 
    "Ancestral Healing Wisdom"
  ]
};

export const features = [
  {
    icon: "dna",
    title: "AI Genealogy Simulator",
    description: "Discover your tribal and ancestral lineage across the Americas through AI analysis of your family names and oral history.",
    details: [
      "Surname etymology analysis",
      "Historical migration mapping",
      "Tribal clan connections"
    ]
  },
  {
    icon: "archive",
    title: "Genealogy Document Storage", 
    description: "Secure digital archive for all your genealogy-related documents, protected from state databases and public indexing.",
    details: [
      "Private tribal vault",
      "Birth records & affidavits",
      "Family photos & maps"
    ]
  },
  {
    icon: "scale",
    title: "Tribal Rights Education",
    description: "Interactive, AI-guided learning modules about treaty protections and how to exercise sovereign rights.",
    details: [
      "Treaty protections",
      "Sovereign travel rights", 
      "Tribal jurisdiction"
    ]
  },
  {
    icon: "users",
    title: "Tribal Assembly Builder",
    description: "Form private tribal governments or spiritual assemblies with our powerful builder tool.",
    details: [
      "Founding charters",
      "Religious trust documents"
    ]
  },
  {
    icon: "shield",
    title: "Tribal Crest Generator",
    description: "Create ancestral family crests and emblems based on your surname heritage and values.",
    details: [
      "Full-resolution artwork",
      "Seal-ready versions", 
      "Cultural blessings & mottos"
    ]
  },
  {
    icon: "map",
    title: "Land & Jurisdiction Mapping",
    description: "Map inherited land or claimed territory and declare it under tribal trust or ecclesiastical jurisdiction.",
    details: [
      "Treaty boundary overlays",
      "Land declaration documents",
      "and signage graphics"
    ]
  },
  {
    icon: "leaf",
    title: "Ancestral Remedy Generator", 
    description: "Receive natural herbal protocols and healing rituals for physical, emotional, or spiritual ailments.",
    details: [
      "Natural herbal protocols",
      "Spiritual cleansing routines",
      "Healing plan cards"
    ]
  },
  {
    icon: "utensils",
    title: "Tribal Table: Plant Medicine",
    description: "Journey through tribal plant medicine systems with healing recipes, plant-as-medicine knowledge, and traditional protocols.",
    details: [
      "Tribal plant remedies by region",
      "Plant-as-medicine knowledge", 
      "AI healing plans by lineage"
    ]
  }
];

export const experienceSteps = [
  {
    title: "Discover Your Lineage",
    description: "Input your family names and oral history to receive a comprehensive analysis of your tribal ancestry."
  },
  {
    title: "Build Your Tribal Identity", 
    description: "Create your family crest, establish tribal governance, and declare your sovereign status."
  },
  {
    title: "Reclaim Ancestral Wisdom",
    description: "Access healing protocols, food wisdom, and spiritual practices from your ancestral traditions."
  }
];

export const formData = {
  regions: [
    "North America",
    "Caribbean", 
    "Central America",
    "South America"
  ]
};

export const testimonials = [
  {
    name: "Michael Johnson",
    location: "Florida", 
    rating: 5,
    quote: "TribalRoot.Ai helped me discover my Seminole and Gullah Geechee ancestry that had been hidden for generations. I've now established a small tribal assembly with my extended family and we're reclaiming our cultural practices."
  },
  {
    name: "Lucia Rodriguez", 
    location: "New Mexico",
    rating: 5,
    quote: "The Tribal Assembly Builder helped our family create a formal structure for our ancestral practices. We've declared our land under ecclesiastical jurisdiction and are now growing traditional foods using the wisdom from the Tribal Table section."
  },
  {
    name: "David Williams",
    location: "Georgia",
    rating: 5, 
    quote: "The ancestral remedy generator has transformed my health. Following protocols based on my Cherokee and West African heritage has helped me address chronic issues that modern medicine couldn't solve. I feel connected to my ancestors in a way I never thought possible."
  }
];

export const ctaSection = {
  title: "Begin Your Journey to Ancestral Sovereignty",
  subtitle: "Join thousands of Indigenous and Afro-Indigenous peoples who are reclaiming their heritage, building tribal infrastructure, and living in sovereignty.",
  buttons: {
    primary: "Subscribe Today",
    secondary: ""
  }
};

export const missionSection = {
  title: "Our Mission", 
  subtitle: "Empowering Indigenous peoples to reclaim their ancestral legacy",
  story: "TribalRoot.Ai was founded by a collective of Indigenous technologists, healers, and legal experts who recognized the need for a comprehensive platform to help people reconnect with their ancestral heritage and exercise their sovereign rights.",
  description: "Our team combines deep knowledge of tribal law, Indigenous healing practices, and cutting-edge artificial intelligence to create a platform that serves as a bridge between ancestral wisdom and modern technology.",
  belief: "We believe that true sovereignty begins with knowing who you are, where you come from, and the rights that are your birthright. Our mission is to make this knowledge accessible to all Indigenous and Afro-Indigenous peoples across the Americas."
};

export const contactInfo = {
  location: {
    address: "PO Box 2539",
    city: "Cypress, TX 77410"
  },
  emails: [
    "support@tribalroot.ai"
  ],
  phones: [],
  hours: {
    weekdays: "Monday - Friday: 9am - 5pm",
    saturday: "Saturday: Closed", 
    sunday: "Sunday: Closed"
  }
};

export const contactSubjects = [
  "General Inquiry",
  "Membership Questions",
  "Technical Support", 
  "Partnership Opportunities"
];